<template>
	<div class="global-search-dropdown-component">

		<div class="search-dropdown-content search-section-title-container" v-if="getResultLength > 0 || top5Projects.length > 0 ">
			<h3
				class="remove-margin search-section-title selected-section"
				v-if="$store.getters.getGlobalSearchResult('projectsByText').length > 0"
				@click="openResultSection($t('globalSearchSections.stories'), $event)"
			>
				{{ $t('globalSearchSections.stories') }}
			</h3>
			<h3
				:class="['remove-margin', 'search-section-title',
				{'selected-section' : $store.getters.isFieldSelected('projectsByTool')
				|| $store.getters.getGlobalSearchResult('projectsByText').length === 0}]"
				v-if="$store.getters.getGlobalSearchResult('projectsByTool').length > 0"
				@click="openResultSection($t('globalSearchSections.tools'), $event)"
			>
				{{ $t('globalSearchSections.tools') }}
			</h3>
			<h3
				:class="['remove-margin', 'search-section-title', {'selected-section' : $store.getters.isFieldSelected('projectsByCertification')}]"
				v-if="$store.getters.getGlobalSearchResult('projectsByCertification').length > 0"
				@click="openResultSection($t('globalSearchSections.certifications'), $event)"
			>
				{{ $t('globalSearchSections.certifications') }}
			</h3>
			<h3 v-if="!$store.getters.getGlobalSearchResult('showResults')"
				:class="['remove-margin', 'search-section-title', 'selected-section', 'normal-cursor']"
			>
				{{ $t('globalSearchSections.top5Projects') }}
			</h3>
			<h3
				:class="['remove-margin', 'search-section-title', {'selected-section' : $store.getters.isFieldSelected('projectsByCompany')}]"
				v-if="$store.getters.getGlobalSearchResult('projectsByCompany').length > 0"
				@click="openResultSection($t('globalSearchSections.companies'), $event)"
			>
				{{ $t('globalSearchSections.companies') }}
			</h3>
			<h3
				:class="['remove-margin', 'search-section-title',
				{'selected-section' : $store.getters.isFieldSelected('projectsByOwner')
				|| $store.getters.getGlobalSearchResult('projectsByOwner').length === 0}]"
				v-if="$store.getters.getGlobalSearchResult('projectsByOwner').length > 0"
				@click="openResultSection($t('globalSearchSections.referenceOwners'), $event)"
			>
				{{ $t('globalSearchSections.referenceOwners') }}
			</h3>
			<h3
				:class="['remove-margin', 'search-section-title',
				{'selected-section' : $store.getters.isFieldSelected('projectsByBusinessContactManager')
				|| $store.getters.getGlobalSearchResult('projectsByBusinessContactManager').length === 0}]"
				v-if="$store.getters.getGlobalSearchResult('projectsByBusinessContactManager').length > 0"
				@click="openResultSection($t('globalSearchSections.businessContactManagers'), $event)"
			>
				{{ $t('globalSearchSections.businessContactManagers') }}
			</h3>
			<h3
				:class="['remove-margin', 'search-section-title',
				{'selected-section' : $store.getters.isFieldSelected('projectsByDeliveryContactManager')
				|| $store.getters.getGlobalSearchResult('projectsByDeliveryContactManager').length === 0}]"
				v-if="$store.getters.getGlobalSearchResult('projectsByDeliveryContactManager').length > 0"
				@click="openResultSection($t('globalSearchSections.deliveryContactManagers'), $event)"
			>
				{{ $t('globalSearchSections.deliveryContactManagers') }}
			</h3>
			<h3
				:class="['remove-margin', 'search-section-title',
				{'selected-section' : $store.getters.isFieldSelected('offers')
				|| $store.getters.getGlobalSearchResult('offers').length === 0}]"
				v-if="$store.getters.getGlobalSearchResult('offers').length > 0"
				@click="openResultSection($t('globalSearchSections.offers'), $event)"
			>
				{{ $t('globalSearchSections.offers') }}
			</h3>
		</div>

		<div class="search-dropdown-content search-section-content-container">
			<GlobalSearchSingleResult
				:id="$t('globalSearchSections.stories')"
				:stories="$store.getters.getGlobalSearchResult('projectsByText')"
				:matchedFilters="[]"
				:hideByDefault="false"
				:isTitleAndMatchTextCombined="false"
			/>

			<GlobalSearchSingleResult
				:id="$t('globalSearchSections.tools')"
				:stories="$store.getters.getGlobalSearchResult('projectsByTool')"
				:matchedFilters="getFilters('tools')"
				:filterType="'tools'"
				:hideByDefault="$store.getters.hideByDefault"
			/>
			<GlobalSearchSingleResult
				:id="$t('globalSearchSections.certifications')"
				:stories="$store.getters.getGlobalSearchResult('projectsByCertification')"
				:matchedFilters="getFilters('certifications')"
				:filterType="'certifications'"
				:hideByDefault="$store.getters.hideByDefault"
			/>
			<GlobalSearchSingleResult
				v-if="!$store.getters.getGlobalSearchResult('showResults')"
				:id="$t('globalSearchSections.top5Projects')"
				:stories="top5Projects"
				:matchedFilters="[]"
				:showNumberOfProjects=5
				:hideByDefault="false"
				:hideShowAllButton="true"
				:isTitleAndMatchTextCombined="false"
			/>
			<GlobalSearchSingleResult
				:id="$t('globalSearchSections.companies')"
				:stories="$store.getters.getGlobalSearchResult('projectsByCompany')"
				:matchedFilters="getFilters('companies')"
				:filterType="'companies'"
				:hideByDefault="$store.getters.hideByDefault"
			/>
			<GlobalSearchSingleResult
				:id="$t('globalSearchSections.referenceOwners')"
				:stories="$store.getters.getGlobalSearchResult('projectsByOwner')"
				:matchedFilters="getFilters('referenceOwners')"
				:filterType="'referenceOwners'"
				:hideByDefault="$store.getters.hideByDefault"
			/>
			<GlobalSearchSingleResult
				:id="$t('globalSearchSections.businessContactManagers')"
				:stories="$store.getters.getGlobalSearchResult('projectsByBusinessContactManager')"
				:matchedFilters="getFilters('businessContactManagers')"
				:filterType="'businessContactManagers'"
				:hideByDefault="$store.getters.hideByDefault"
			/>
			<GlobalSearchSingleResult
				:id="$t('globalSearchSections.deliveryContactManagers')"
				:stories="$store.getters.getGlobalSearchResult('projectsByDeliveryContactManager')"
				:matchedFilters="getFilters('deliveryContactManagers')"
				:filterType="'deliveryContactManagers'"
				:hideByDefault="$store.getters.hideByDefault"
			/>
			<GlobalSearchSingleOfferResult
				:id="$t('globalSearchSections.offers')"
				:offers="$store.getters.getGlobalSearchResult('offers')"
				:hideByDefault="$store.getters.hideByDefault"
				:isTitleAndMatchTextCombined="true"
			/>
			<div
				v-if="getResultLength === 0 && $store.getters.getGlobalSearchResult('word') !== ''"
				class="no-results-from-global-search"
			>
				{{$t('globalSearchSections.noMatch')}}
			</div>
		</div>

	</div>
</template>

<script>
import * as GLOBAL_SEARCH_SERVICE from "@/drc/services/global-search-service";
import {EventGlobalSearch} from "@/common/configurations/event-bus.js";
import GlobalSearchSingleResult from "@/drc/components/globalSearch/GlobalSearchSingleResult";
import * as PROJECTS_SERVICE from "@/drc/services/drc-request-service";
import GlobalSearchSingleOfferResult from "@/drc/components/globalSearch/GlobalSearchSingleOfferResult";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";

export default {
	name: "GlobalSearchResultsDropdown",
	components: {GlobalSearchSingleResult, GlobalSearchSingleOfferResult},
	data() {
		return {
			timeoutId: undefined,
			top5Projects: [],
			isTop5ProjectsOpen: true
		}
	},
	computed: {
		getResultLength() {
			return this.$store.getters.getGlobalSearchResultsLength;
		}
	},
	created() {
		EventGlobalSearch.$on('trigger-global-search', this.triggerGlobalSearch)
	},
	destroyed() {
		EventGlobalSearch.$off('trigger-global-search')
		this.$store.dispatch('resetGlobalSearch')
	},
	methods: {
		getFilters(type) {
			let word = this.$store.getters.getGlobalSearchResult('word');
			let array = this.$store.getters.getSearchByFilters('filters')[type]
			return array ? array.filter(item => item.name.toLowerCase().includes(word.toLowerCase())) : [];
		},
		openResultSection(id, event) {
			this.isTop5ProjectsOpen = false;
			this.openSection(id);
			this.markButtonAsSelected(id, event);
		},
		markButtonAsSelected(id, event) {
			this.deselectButtons();
			event.target.classList.add('selected-section');
		},
		deselectButtons() {
			Array.from(document.getElementsByClassName('search-section-title'))
				.forEach(elem => {
					elem.classList.remove('selected-section')
				})
		},
		openSection(id) {
			this.hideSections(id);
			document.getElementById(id).classList.remove('hide-result-content');
		},
		hideSections(id) {
			Array.from(document.getElementsByClassName("global-search-stories"))
				.filter(elem => elem.id !== id)
				.forEach(elem => {
					elem.classList.add('hide-result-content')
				});
		},
		triggerGlobalSearch(newValue) {
			clearTimeout(this.timeoutId);
			this.timeoutId = setTimeout(() => {
				if (newValue.trim() === "") {
					this.$store.dispatch('resetGlobalSearch');
					return;
				}
				GLOBAL_SEARCH_SERVICE.getResults(newValue, this.$i18n.locale);
				const now = new Date();
				this.$gtag.event("SEARCH_ON_HOME_PAGE", {
					event_type: "search",
					event_category: "drc",
					event_page: "home",
					event_label: "Global search on home page",
					event_location: this.$route.name,
					event_path: this.$route.path,
					user_id: this.$store.getters.getUser.id,
					user_name: this.$store.getters.getUser.fullName,
					user_email: this.$store.getters.getUser.email,
					year: now.getFullYear(),
					month: now.getMonth() + 1,
					day: now.getDate(),
					time: new Date().toJSON().split('T')[1].split('.')[0],
					search_term: newValue
				});
				const props = {
					action: "SEARCH_ON_HOME_PAGE",
					comment: JSON.stringify({search_type: "GLOBAL_SEARCH", keyword: `${newValue}`})
				}
				STATISTIC_SERVICE.addDrcStatistic(props);
			}, 400);
		},
		fetchNewestProjects(number,lang) {
			PROJECTS_SERVICE.getLatestProjects2(number,lang)
				.then((response) => {
					this.top5Projects = response.data
				})
				.catch((errors) => {
					console.error(errors);
				})
		},
	},
	mounted() {
		this.fetchNewestProjects(5, this.$i18n.locale)
	}
}
</script>
